<template>
  <div v-loading="loading" class="new-question-show flex-1 overflow-auto">
    <render-container-group>
      <render-container v-for="qs of questionList" :key="qs.q_id">
        <preview-question  :question="qs" :enableQuestionIndex="enableQuestionIndex"/>
      </render-container>
    </render-container-group>
  </div>
</template>

<script>
import pc from 'pc'
import { createQuestionFactory } from '@dygc/question'
import { detail } from '@/api/wenjuan/answerList'
const PreviewQuestion = pc.PreviewQuestion
import { convertAnswerText } from '@/question/convert.js'
import { getQuestionNo, getColsestDif, isPreNo } from '@/components/survey-detail/detailMeans'
import RenderContainerGroup from '@/components/base/RenderContainerGroup.vue'
import RenderContainer from '@/components/base/RenderContainer.vue'

export default {
  name: 'NewQuestionShow',
  components: {
    RenderContainer, RenderContainerGroup,
    PreviewQuestion // 答卷详情预览
  },
  props: {
    answerId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      feikaiArr: [],
      questionList: [],
      loading: false
    }
  },
  computed:{
    enableQuestionIndex(){
      return this.$store.getters.otherSetting?.enableQuestionIndex !== false
    }
  },
  watch: {
    answerId(n) {
      if (n) this.getDetail(n)
    }
  },
  methods: {
    getQuestionNo,
    getColsestDif,
    isPreNo,
    getDetail(aswId) {
      this.loading = true
      detail(aswId).then(res => {
        const d = res.data.data
        this.feikaiArr = d.answerContent
        this.feikaiArr.length && this.getQuestionNo()
        this.questionList = this.feikaiArr.filter(item=>item.questionDetails).map((item) => {
          item.questionDetails = {
            ...item.questionDetails,
            content: {
              ...item.questionDetails.content,
              text: convertAnswerText(item.questionDetails.content.richText || item.questionDetails.content.text, d.answerContent),
              richText: convertAnswerText(item.questionDetails.content.richText || item.questionDetails.content.text, d.answerContent)
            }
          }
          const q = createQuestionFactory(item.questionDetails)
          q.setValue(item)
          q.disabledProgress = true
          q.num = item.questionNo
          return q
        })
        this.loading = false
      })
    }
  },
  created() {
    this.getDetail(this.answerId)
  }
}
</script>
